(ns hypnos.datadog
  (:require
    ["@datadog/browser-rum" :as rum :refer [datadogRum]]
    [hypnos.config :as config]))

(def ^:private blacklist-filters
  [;; amplify pubsub spuriously logs new subscriptions as errors
   #(= js/console.error (some-> (first %) .-_observer .-start))])

(defn- monkeypatch-console-error
  []
  (let [orig-console-error (.-error js/console)]
    (set! (.-error js/console)
          #(when-not ((apply some-fn blacklist-filters) %&)
             (apply orig-console-error %&)))))

(defn init
  []
  (.init datadogRum (clj->js config/DATADOG))
  (monkeypatch-console-error))
